import { History } from "history";
import { calculateDevice } from "../constants/breakpoints";
import { WotdFormData } from "../beans/api";
import { BASE_PATH } from "../constants/endpoint";

export const isTabletOrMobile = (): boolean =>
  ["tablet", "mobile"].includes(calculateDevice(window.innerWidth));

export const getTitleHeadingLevel = (): 1 | 2 => {
  return isTabletOrMobile() ? 2 : 1;
};

export const getContentHeadingLevel = (): 3 | 4 => {
  return isTabletOrMobile() ? 4 : 3;
};

export const getContentHeadingVariant = (): "-lt" | "" => {
  return isTabletOrMobile() ? "-lt" : "";
};

export function goToPage(
  page: string,
  history: History,
  basePath?: string,
): void {
  if (!basePath) basePath = BASE_PATH;
  history.push(`${basePath}${page}`);
}

export function checkWotdValidation(obj: WotdFormData["words"]): boolean {
  for (const val of Object.values(obj)) {
    if (val) {
      return true;
    }
  }
  return false;
}

export function checkPersonalDataValidation(
  obj: WotdFormData["personalData"],
): boolean {
  const values = Object.values(obj);
  for (const val of values) {
    if (!val) return false;
  }
  return true;
}
